import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-team",
  "use": "icon-team-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-team\">\n  <path d=\"M17.92 9A9 9 0 0018 7.77V6H2v1.77A9 9 0 002.08 9h15.84zm-.2 1H2.28a9 9 0 004.09 5.49L10 17.67l3.63-2.18A9 9 0 0017.72 10zM18 5V2H2v3h16zM0 0h20v7.77a11 11 0 01-5.34 9.43L10 20l-4.66-2.8A11 11 0 010 7.77V0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol